document.querySelectorAll<HTMLElement>('[data-micromodal-trigger]').forEach((trigger) => {
	trigger.addEventListener('click', (e) => {
		e.preventDefault();
		const modalId = trigger.dataset.micromodalTrigger;

		if (modalId) {
			window.MicroModal.show(modalId, {
				awaitOpenAnimation: true,
				awaitCloseAnimation: true,
				disableScroll: true,
			});
		}
	});
});
